import {
  Image,
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { CommonButton } from "../../../common/CommonButton";
import { AppImages } from "../../../utility/AppImages";

export default function SelectPollModal(props) {
  const { showModal = false, setShowModal, loading = false } = props;

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [pollMinutes, setPollMinutes] = useState(5);

  const formatTime = (minutes) => {
    return `${minutes.toString().padStart(2, "0")}:00`;
  };

  const incrementTime = () => {
    setPollMinutes((prev) => {
      const newMinutes = prev + 5;
      return newMinutes > 60 ? 60 : newMinutes;
    });
  };

  const decrementTime = () => {
    setPollMinutes((prev) => {
      const newMinutes = prev - 5;
      return newMinutes < 5 ? 5 : newMinutes;
    });
  };

  const onCloseClick = () => {
    setShowModal(false);
  };
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.MEDIUM_ANYBODY_20
                  : AppFontStyle.MEDIUM_ANYBODY_24,
                {},
              ]}
            >
              Select time for the poll
            </Text>
            <TouchableOpacity
              onPress={onCloseClick}
              activeOpacity={0.5}
              style={{
                padding: 7,
                backgroundColor: AppColors.gray_212222,
                borderWidth: 1,
                borderColor: AppColors.grayColor_393939,
                borderRadius: 6,
              }}
            >
              <Image
                source={AppImages.icCloseWhiteSvg}
                style={{
                  height: 16,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>
          <View style={{ gap: 6, width: "100%" }}>
            <Text style={[AppFontStyle.MEDIUM_ANYBODY_14, {}]}>Poll Time</Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: AppColors.black_131016,
                borderColor: AppColors.gray_5C5C5C,
                borderWidth: 1,
                borderRadius: 8,
                paddingHorizontal: 12,
                paddingVertical: 8,
              }}
            >
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                }}
              >
                <Text style={[AppFontStyle.REGULAR_ANYBODY_16, {}]}>
                  {formatTime(pollMinutes)}
                </Text>
              </View>
              <View style={{ flexDirection: "column", gap: 5 }}>
                <TouchableOpacity onPress={incrementTime}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_16, {}]}>▲</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={decrementTime}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_16, {}]}>▼</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
          <View>
            <View style={styles.divider} />
            <View style={{ alignItems: "flex-end", paddingTop: 12 }}>
              <CommonButton
                title={loading ? "Updating..." : "Send for poll"}
                onTap={() => {
                  setShowModal(false);
                  console.log(`Poll set for ${formatTime(pollMinutes)}`);
                }}
                buttonStyle={{
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  shadowOpacity: 0,
                  borderRadius: 8,
                }}
                disabled={loading}
                textStyle={[AppFontStyle.REGULAR_ANYBODY_16, {}]}
              />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      height: "auto",
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      borderRadius: 24,
      gap: 22,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
      width: "50%",
    },
    divider: {
      height: 1,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "95%",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "95%",
      },
    },
  }
);
